//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// &nbsp; добавлен в связи с багом в библиотеке @linusborg/vue-simple-portal (https://github.com/LinusBorg/vue-simple-portal/issues/20)

import Dialog from '../../../../components/dialog';

export default ({
  extends: Dialog,
  // дополнительные свойства и методы
});
